const NoAudio = ():JSX.Element => (
  <div>
    <p>
      Unfortunately your browser does not support
      <code>Audio API</code>
    </p>
    <p>Virtual Keyboard depends on it to work :(</p>
  </div>
);

export default NoAudio;